import SscaLogo from '@app/components/ssca-logo';
import { useTranslation } from 'react-i18next';

const SscaCopyrights = () => {
    const { t } = useTranslation();

    return (
        <div className="ssca-copyright flex w-full gap-1 items-center justify-center text-center text-xs text-muted-foreground">
            <p>{t('common.copyrights.ssca', { date: new Date().getFullYear() })}</p>
            <a
                href="https://station-ssca.com"
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center justify-center gap-1"
            >
                <SscaLogo height={18} width={84} />
            </a>
        </div>
    );
};

export default SscaCopyrights;
